import React from 'react';
import { Book } from 'lucide-react';

export default function Research() {
    return (
        <section id="research" className="mb-12 px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl sm:text-3xl font-bold mb-6 pb-2 border-b-2 border-blue-500">
                THESIS/RESEARCH WORK
            </h2>
            <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex flex-col sm:flex-row sm:justify-between items-start mb-4">
                    <h3 className="font-bold text-lg sm:text-xl text-blue-800">
                        Master's Thesis Project, IIT Hyderabad
                    </h3>
                    <span className="text-gray-600 mt-2 sm:mt-0">Jan&apos;24 - Present</span>
                </div>
                <p className="mb-2 text-sm sm:text-base">
                    <strong>Supervised by:</strong> Prof. Sobhan Babu Chintapalli
                </p>
                <p className="mb-4 flex items-center gap-2 text-sm sm:text-base">
                    <Book size={16} className="text-blue-800" />
                    <strong>Title:</strong> Synthetic Electronic Health Records Generation: A Transformer-Based Approach
                </p>
                <ul className="list-disc pl-6 space-y-2 text-gray-800 text-sm sm:text-base leading-relaxed">
                    <li>
                        Conducting research to develop synthetic data for enhancing electronic health records (EHRs), focusing on data privacy and availability.
                    </li>
                    <li>
                        Utilizing advanced machine learning techniques, including CTGAN and Transformer-based models, to generate realistic synthetic health records.
                    </li>
                    <li>
                        Addressing critical challenges in healthcare data management, privacy compliance, and financial data utilization by providing innovative and scalable solutions.
                    </li>
                </ul>
            </div>
        </section>
    );
}
